import React from "react";
import { ScreenHeading } from "../../componets/ScreenHeading/ScreenHeading";
import { ScrollService } from "../../componets/ScrollService";
import { Animations } from "../../componets/Animations";
import "./Resume.css";

export function Resume(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  return (
    <div
      className={"projectImages-container screen-container fade-in"}
      id={props.id || ""}
    >
      <div className={"projectImages-parent"}>
        <ScreenHeading title={"CV"} />
        <div className={"pdf-card"}>
          <iframe
            title={"pdfFrame"}
            className={"myPDF"}
            src="myCV.pdf"
            frameBorder={0}
          />
        </div>
      </div>
    </div>
  );
}
